import { createContext, useContext, useRef } from "react";

const ScrollContext = createContext(null);

export const ScrollProvider = ({ children }) => {
    const loadMoreRef = useRef(null);

    const registerLoadMore = (fn) => {
        loadMoreRef.current = fn;
    };

    const triggerLoadMore = () => {
        if (loadMoreRef.current) {
            loadMoreRef.current();
        }
    };

    return (
        <ScrollContext.Provider value={{ registerLoadMore, triggerLoadMore }}>
            {children}
        </ScrollContext.Provider>
    );
};

export const useScrollContext = () => useContext(ScrollContext);
